import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const basePath = "/api/zival/zgodovina";

export const getAnimalHistoryById = createAsyncThunk(
  "animalHistory/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${basePath}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getAnimalHistoryPage = createAsyncThunk(
  "animalHistory/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${basePath}/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const animalHistorySlice = createSlice({
  name: "animalHistory",
  initialState: {
    details: {},
    page: {},
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAnimalHistoryById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(getAnimalHistoryById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getAnimalHistoryById.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAnimalHistoryPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getAnimalHistoryPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getAnimalHistoryPage.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default animalHistorySlice.reducer;
